import api from "./api";

export const teststepsService = {
  getTestSteps: async (test_case_id, params = {}) => {
    const requestData = { test_case_id, ...params };
    const response = await api.post("/teststeps/list", requestData);
    return response.data;
  },

  getTestStepById: async (test_case_id, step_id) => {
    const response = await api.post("/teststeps/get", {
      test_case_id,
      step_id,
    });
    return response.data;
  },

  createTestStep: async (test_case_id, data) => {
    const response = await api.post("/teststeps/create", {
      test_case_id,
      ...data,
    });
    return response.data;
  },

  updateTestStep: async (test_case_id, step_id, data) => {
    const response = await api.post("/teststeps/update", {
      test_case_id,
      step_id,
      ...data,
    });
    return response.data;
  },

  deleteTestStep: async (test_case_id, step_id) => {
    const response = await api.post("/teststeps/delete", {
      test_case_id,
      step_id,
    });
    return response.data;
  },

  reorderTestSteps: async (test_case_id, stepIds) => {
    const response = await api.post("/teststeps/reorder", {
      test_case_id,
      stepIds,
    });
    return response.data;
  },

  bulkCreateTestSteps: async (test_case_id, steps) => {
    const response = await api.post("/teststeps/bulk", { test_case_id, steps });
    return response.data;
  },
};
